import { convertToSlug } from '../api/utils';
enum size {
  Square = 'Square',
  Landscape = 'Landscape',
  Portrait = 'Portrait',
}
export default defineNuxtPlugin((app) => {
  const {
    $auth,
    $globals,
    $api,
    $dialogs,
    $rating,
    $subscription,
    $emitter,
    $customGtm,
    $like,
  } = app;
  const router = useRouter();
  const { checkIfCanConsume } = usePurchase();
  const { userHistoryHandler } = useUserHistory();
  const localePath = useLocalePath();
  const game = reactive({
    viewedStories: {} as any,
    playedGameId: 0,
    searchTextInput: '',
    gameUrl: '',
    isFullscreen: false,
    isControlBarVisible: true,
    getStories() {
      if (process.server) {
        return;
      }
      try {
        const viewedStoriesJSON = JSON.parse(
          localStorage.getItem('viewedStories') || '{}',
        );
        game.viewedStories = viewedStoriesJSON;
      } catch (error) {
        throw error;
      }
    },
    setViewed(itemId: number, isWatched: boolean, index: number | string) {
      if (!itemId) return;
      // $set(viewedStories, itemId, { isWatched, index });
      // need to double check
      game.viewedStories = {
        ...game.viewedStories,
        [itemId]: { isWatched, index },
      };
      localStorage.setItem('viewedStories', JSON.stringify(game.viewedStories));
    },
    isViewed(itemId: number): boolean {
      return game.viewedStories?.[itemId]?.isWatched;
    },
    async download(
      gameInfo: any,
      gameId?: number,
      redirect?: string,
      referralSource?: string,
    ) {
      await $api.endPoints.getDeviceInfo();
      if (!gameInfo && gameId) {
        gameInfo = await game.getGameDetails(gameId);
      }
      if (!$dialogs.loader) {
        $dialogs.loader = true;
      }
      if (gameId) {
        if (!gameInfo) {
          gameInfo = {};
        }
        gameInfo.id = gameId;
      }

      const isConsumable = await checkIfCanConsume(
        gameInfo,
        gameInfo.id,
        redirect,
        referralSource,
      );
      if (!isConsumable && !gameInfo.isWalletItem) {
        return;
      }
      let url;

      if (isConsumable && isConsumable.action) {
        // play the game by url
        url = isConsumable.url;
        if (process.client) {
          window.location.href = url;
        }
      } else {
        // url = await getOnlineGameUrl(game.id);
        let res = await game.getDownloadableGameUrl(gameInfo, referralSource);
        url = res.uri;
      }
      $dialogs.loader = false;
      userHistoryHandler(gameInfo);

      if (redirect) {
        if ($dialogs.storiesDialog) {
          $dialogs.storiesDialog = false;
        }
      }

      if ($api.endPoints.operatingSystem === 'ANDROID') {
        if (process.client) {
          window.location.href = url;
        }
        const userWallet = await $rating.getUserWallet(gameInfo.id);
        // we need to double check the belw line
        //   $emit('userWallet', userWallet);
        if (redirect) {
          router.push(
            localePath(
              game.gamePath(
                gameId ? gameId : $dialogs.storyItem?.id,
                gameInfo.title,
              ),
            ),
          );
        }
        return;
      } else {
        // $snackbar.snackbar = true;
        // $snackbar.text = $t('downloadNotAvailable');
        $dialogs.deviceNotSupported = true;
        // console.info('not supported');
      }
    },
    async getOnlineGameUrl(
      gameId: string,
      referralSource?: string,
    ): Promise<string | void> {
      try {
        return await $api.endPoints.getOnlineGameUrl(gameId, referralSource);
      } catch (err) {
        // Skip error
        // console.info(err, 'error online game url');
        throw 'error online game url';
      }
    },
    async getDownloadableGameUrl(
      game: any,
      referralSource?: string,
    ): Promise<any | void> {
      try {
        return await $api.endPoints.getDownloadableGameUrl(
          game,
          referralSource,
        );
      } catch (err) {
        //skip error;
        // console.info(err, 'error download game url');
        throw 'error download game url';
      }
    },
    async getOnlineGameFreeUrl(
      gameId: string,
      referralSource?: string,
    ): Promise<any> {
      try {
        return await $api.endPoints.getOnlineGameFreeUrl(
          gameId,
          referralSource,
        );
      } catch (err) {
        // skip error
        // console.info(err, 'error online game free url');
      }
    },
    async play(
      gameData: any,
      gameId?: number,
      redirect?: string | null,
      gameUrl?: string | null,
      carouselTitle?: string | null,
      referralSource?: string | null,
      openInIframe?: boolean | null,
    ) {
      let gameInfo = gameData;
      if (!gameInfo && gameId) {
        gameInfo = await game.getGameDetails(gameId);
      }
      if (!$dialogs.loader) {
        $dialogs.loader = true;
      }
      if (gameId) {
        if (!gameInfo) {
          gameInfo = {};
        }
        gameInfo.id = gameId;
      }
      if (!game.isLoggedIn() && game.isFreeOnlineGame(gameInfo)) {
        let url = await game.getOnlineGameFreeUrl(gameInfo.id, referralSource);
        if ($globals.enabledFeatures?.gameBarPdp == 'true' && !openInIframe) {
          game.gameUrl = url;
          return;
        } else if (
          $globals.enabledFeatures?.allowGamingInIframe == 'true' ||
          openInIframe
        ) {
          $dialogs.openGameHtmlIFrame(gameInfo, url);
        } else {
          game.onlineGameRedirection(gameInfo, gameId, redirect, url);
        }
        $dialogs.loader = false;
        return;
      }
      const isConsumable = await checkIfCanConsume(
        gameInfo,
        gameInfo.id,
        redirect,
        referralSource,
      );
      if (!isConsumable) {
        return;
      }
      ///// .
      let url;
      if (gameUrl) {
        url = gameUrl;
      } else if (isConsumable && isConsumable.action) {
        url = isConsumable.url;
      } else {
        url = await game.getOnlineGameUrl(gameInfo.id, referralSource);
      }
      $customGtm?.track({
        EN: 'cta_click',
        AT: 'click',
        BN: 'Instant Play',
        AI: gameInfo?.id,
        AN: gameInfo?.name,
        // AT:gameInfo?.contentType,
        AL: gameInfo?.licensorName,
        DU: url,
        PSC: carouselTitle,
      });
      game.playedGameId = gameInfo.id;
      $dialogs.loader = false;

      if (gameInfo.customProperties?.useGameFrame) {
        return $emitter.emit('gameUrlReady', url);
      }
      if ($globals.enabledFeatures?.gameBarPdp == 'true' && !openInIframe) {
        game.gameUrl = url;
        return;
      } else if (
        $globals.enabledFeatures?.allowGamingInIframe == 'true' ||
        openInIframe
      ) {
        $dialogs.openGameHtmlIFrame(gameInfo, url);
      } else {
        game.onlineGameRedirection(gameInfo, gameId, redirect, url);
      }
    },
    async onlineGameRedirection(
      onlineGame: { [key: string]: string },
      gameId: number | string,
      redirect: string,
      url: string,
    ) {
      if (url) {
        let popup;
        if (process.client) {
          popup = window.open(url, '_blank');
        }
        if (!popup || (popup && $globals.isPopupBlockerActivated(popup))) {
          // workaround for Safari
          const a = document.createElement('a');
          a.href = url;
          document.body.append(a);
          a.click();
        } else {
          if (redirect) {
            if ($dialogs.storiesDialog) {
              $dialogs.storiesDialog = false;
            }

            router
              .push(
                localePath(
                  game.gamePath(
                    gameId ? gameId : $dialogs.storyItem?.id,
                    onlineGame.title,
                  ),
                ),
              )
              .catch(() => {});
          }
        }

        // we need to double check the belw line
        //   const userWallet = await $rating.getUserWallet(onlineGame.id);
        //   $emit('userWallet', userWallet);
      }
    },
    async getGameDetails(gameId: number) {
      const getArticleRes = (await $api.endPoints.getStructure(
        'fragments_get-article-details',
        { id: gameId },
      )) as any;
      let game = getArticleRes?.[0]?.data;
      return game;
    },
    isLoggedIn() {
      let user = $auth.user;
      return user?.roles[0] === 'user';
    },
    gamePath(gameId: number, gameTitle: string) {
      const gamePartialPath = gameId
        ? `${convertToSlug(gameTitle)}/${gameId}`
        : convertToSlug(gameTitle);
      return `/games/details/${gamePartialPath}`;
    },
    genrePath(title: string, id: number, localizedName: string) {
      const pathInfo = id ? `${convertToSlug(title, true)}/${id}` : title;
      let path = `/games/category/${pathInfo}?`;
      if (localizedName) {
        path += `genre=${localizedName}`;
      }
      return path;
    },
    publisherPath(item: { [key: string]: string }) {
      return `/games/publisher/${convertToSlug(item.developerName)}`;
    },
    gameTrailers(item: {}, size: string, addetionalSize = null): any {
      let stories: any[] = [];
      const storiesImages = (item as any)?.additionalArtworks?.filter(
        (e: any) => e.artworkClass === 'SCREENSHOT', // TODO: this should be changed to a new type story
      );
      const storiesVideos = (item as any)?.additionalArtworks
        ?.filter(
          (e: any) =>
            (e.artworkClass === 'VIDEO_GAMEPLAY' ||
              e.artworkClass === 'VIDEO_TRAILER') &&
            (e.group?.includes(size) ||
              game.calcDimension(e, size) ||
              (addetionalSize &&
                (e.group?.includes(addetionalSize) ||
                  game.calcDimension(e, addetionalSize)))),
        )
        .sort(function (el: { [key: string]: string }) {
          if (
            el.artworkClass === 'VIDEO_TRAILER' ||
            el.artworkClass === 'VIDEO_GAMEPLAY'
          ) {
            return -1;
          } else {
            return 1;
          }
        });
      // TODO: this should be changed to a new type story
      if (storiesVideos?.[0]) {
        stories = stories.concat(storiesVideos?.[0], storiesImages);
      } else {
        stories = stories.concat(storiesImages);
      }
      return stories;
    },
    getImageOrientBySize(item: any, size: string): any {
      const matchedImage = (item as any)?.additionalArtworks?.find(
        (e: any) =>
          (e.artworkClass === 'SCREENSHOT' || e.artworkClass === 'BANNER') &&
          game.calcDimension(e, size),
      );
      return matchedImage;
    },
    calcDimension(e: { [key: string]: string }, ratio: string) {
      switch (ratio) {
        case size.Portrait:
          return e.height > e.width;
        case size.Landscape:
          return e.height < e.width;
        case size.Square:
          return e.height == e.width;
        default:
          return false;
      }
    },
    gamesContentTypeCTAText(article: any, recentGame?: Object) {
      if (article?.contentType?.toLowerCase() == 'game') {
        return 'download.label';
      } else if (recentGame?.isHistory) {
        return 'historyPlay.label';
      } else {
        return 'goPlay.label';
      }
    },
    gamesCTAText(article: any, recentGame?: Object) {
      // in case the article has offer attributes to check on the subscription types
      const articleOfferAttributes =
        $subscription?.articleHasOfferAttributes(article);
      const isUserSubscribedToArticle =
        $subscription?.isUserSubscribedToArticle(
          articleOfferAttributes,
          'game',
        );
      if (game.isFreeOnlineGame(article)) {
        return 'goPlayFree.label';
      }
      if (!game.isLoggedIn()) {
        return 'goPlay.signin';
      } else if (articleOfferAttributes?.length && isUserSubscribedToArticle) {
        return game.gamesContentTypeCTAText(article, recentGame);
      } else if (articleOfferAttributes?.length && !isUserSubscribedToArticle) {
        let IsGameEligibleForUpgrade = $subscription?.IsGameEligibleForUpgrade(
          articleOfferAttributes,
        );
        if (IsGameEligibleForUpgrade) {
          return 'subscription.upgrade';
        } else if (recentGame?.isHistory) {
          return 'historyPlay.label';
        }
        return 'games.NoActiveSubscriptionBtn';
      } else {
        return game.gamesContentTypeCTAText(article, recentGame);
      }
    },
    isFreeOnlineGame(game: { [key: string]: any }) {
      return game?.prices?.some(
        (item: { [key: string]: string }) =>
          item?.businessModel == 'DOWNLOAD_TO_OWN_FREEMIUM',
      );
    },
    clearGameUrl() {
      game.gameUrl = '';
    },
    toggleFullscreen(value: boolean) {
      game.isFullscreen = value;
      if (game.isFullscreen) {
        game.isControlBarVisible = true;
      }
    },
    toggleControlBar() {
      game.isControlBarVisible = !game.isControlBarVisible;
    },
    addGameToFavorite(item: { contentType: any }) {
      $like.toggleGame(item?.contentType, item);
    },
  });
  game.getStories();
  return {
    provide: {
      game,
    },
  };
});
